export const handleTransactionComplete = () => {
  sessionStorage.removeItem("recipient_id");
  sessionStorage.removeItem("recipient_name");
  sessionStorage.removeItem("transactionId");
};
